import type { AiAppCenterModule } from '../types'

/**
 * 跑腿服务模块
 * 后端 system_module.name=errand；管理端菜单根路径 /errand
 */
export const errandModule: AiAppCenterModule = {
  key: 'errand',
  label: '跑腿服务模块',
  desc: '帮取送 / 帮我买 / 帮个忙；骑手与订单管理',
  path: '/errand',
  standalonePath: '/ai-Application-center/errand/order',
  homePath: '/ai-Application-center/errand/order',
  homeTitles: ['订单管理', '数据概览'],
  // 库表菜单根已迁到带中心前缀路径
  menuPaths: ['/errand', '/ai-Application-center/errand'],
  icon: 'ep:van',
  color: '#22c55e',
  aliases: ['跑腿', '跑腿管理', '跑腿服务', '跑腿服务模块', 'errand']
}
